
import { defineComponent } from "vue";
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { Quiz } from "@/pages/Quiz.vue";
import Button from "@/components/buttons/Button.vue";
import FetchingError from "@/components/fetching-error/FetchingError.vue";
import Heading1 from "@/components/headings/Heading1.vue";
import TextInput from "@/components/form/TextInput.vue";
import Select from "@/components/form/Select.vue";

export type FormValues = {
  name: string;
  quizId: string;
};

export default defineComponent({
  name: "QuizForm",
  components: {
    Button,
    FetchingError,
    Heading1,
    TextInput,
    Select,
  },
  data: () => ({
    v$: useVuelidate(),
    fetchingError: false,
    loading: true,
    selectOptions: [] as Quiz[],
    formValues: {
      name: "",
      quizId: "",
    } as FormValues,
  }),
  emits: ["onSubmit"],
  created() {
    axios
      .get("/test-quiz.php", {
        params: {
          action: "quizzes",
        },
      })
      .then(({ data }) => {
        this.selectOptions = data;
        this.loading = false;
      })
      .catch((error) => {
        if (error) {
          this.fetchingError = true;
        }
      });
  },
  methods: {
    submitForm() {
      this.v$.$validate();
      if (this.v$.$error) {
        return;
      }

      this.$emit("onSubmit", this.formValues);
      this.formValues = {
        name: "",
        quizId: "",
      };
    },
  },
  validations: {
    formValues: {
      name: {
        required: helpers.withMessage("Please enter your name", required),
      },
      quizId: {
        required: helpers.withMessage(
          "Please choose one of the test variants",
          required
        ),
      },
    },
  },
});
